import { array, boolean, mixed, number, object, string } from "yup";
import {
  ClinicFeatureResource,
  clinicFeatureResourceSchema,
} from "./ClinicFeatureResource";
import { ClinicType } from "@client/settings";
import { SubscriptionPlanCode } from "./CurrentSubscriptionResource";

interface ClinicOwnerDto {
  id: number;
}

export interface ClinicDto {
  id: number;
  name: string;
  email: string | null;
  logo: string | null;
  timezone: string;
  owner: ClinicOwnerDto;
  createdAt: string;
  isNew: boolean;
  type: ClinicType;
}

interface SubscriptionPlanDto {
  id: number;
}

interface CurrentUsagePeriodDto {
  startsAt: string;
  endsAt: string;
}

export interface SubscriptionDto {
  uuid: string;
  plan: SubscriptionPlanDto;
  name: string;
  code: SubscriptionPlanCode;
  createdAt: string;
  startsAt: string;
  endsAt: string | null;
  currentUsagePeriod: CurrentUsagePeriodDto | null;
}

interface WhitelabelMotherClinicDto {
  name: string;
}

export interface WhitelabelDto {
  motherClinic: WhitelabelMotherClinicDto | null;
  partnerClinic: boolean | null;
}

export interface ClinicResource {
  clinic: ClinicDto;
  // subscription: SubscriptionDto | null;
  features: ClinicFeatureResource[] | null;
  whitelabel: WhitelabelDto;
}

const clinicOwnerSchema = object({
  id: number().required(),
});

const clinicSchema = object({
  id: number().required(),
  name: string().required(),
  email: string().nullable().default(null),
  logo: string().nullable().default(null),
  timezone: string().required(),
  owner: clinicOwnerSchema.required(),
  createdAt: string().required(),
  isNew: boolean().required(),
  type: mixed<ClinicType>()
    .oneOf(Object.values(ClinicType) as ClinicType[])
    .required(),
});

const currentUsagePeriodSchema = object({
  startsAt: string().required(),
  endsAt: string().required(),
});

const subscriptionPlanSchema = object({
  id: number().required(),
});

const subscriptionSchema = object({
  uuid: string().required(),
  plan: subscriptionPlanSchema.required(),
  name: string().required(),
  code: mixed<SubscriptionPlanCode>()
    .oneOf(Object.values(SubscriptionPlanCode) as SubscriptionPlanCode[])
    .required(),
  createdAt: string().required(),
  startsAt: string().required(),
  endsAt: string().nullable().default(null),
  currentUsagePeriod: currentUsagePeriodSchema.nullable().default(null),
});

const whitelabelMotherClinicSchema = object({
  name: string().required(),
});

const whitelabelSchema = object({
  motherClinic: whitelabelMotherClinicSchema.nullable().default(null),
  partnerClinic: boolean().nullable().default(null),
});

export const clinicResourceSchema = object({
  clinic: clinicSchema.required(),
  // subscription: subscriptionSchema.nullable().default(null),
  features: array().of(clinicFeatureResourceSchema).nullable().default(null),
  whitelabel: whitelabelSchema.required(),
});
